<div class="flex flex-column gap-1">
  <label [id]="id" *ngIf="label"
    ><b>{{ label }}</b></label
  >
  <ng-content />
</div>
